/* PODIFY canvas engine v2 — PARAMETRIC: render(name, {fontId, layoutId}) nhiều font/layout trong 1 SP.
 * Cache theo id + lazy-load bộ đang chọn. Config: window.PODIFY_CFG = { r2, fontId, layoutId, printArea }.
 * Phụ thuộc: podify-kern.js (window.computePositions). Dùng PROFILES (L/R font.json) -> không getImageData -> không taint. */
(function () {
  var CFG = window.PODIFY_CFG || {};
  var R2 = (CFG.r2 || "https://cdn.blazorastore.com").replace(/\/+$/, "");
  var DEF_FONT = CFG.fontId || "beer1";
  var DEF_LAYOUT = CFG.layoutId || "";
  var PA = CFG.printArea || null;                    // fallback vị trí khi layout chưa có manifest
  var ACCENT = { "ä":"ae","ö":"oe","ü":"ue","ß":"ss","á":"a","à":"a","â":"a","ã":"a","å":"a","é":"e","è":"e","ê":"e","ë":"e",
    "í":"i","ì":"i","î":"i","ï":"i","ó":"o","ò":"o","ô":"o","õ":"o","ø":"o","ú":"u","ù":"u","û":"u","ñ":"n","ç":"c","ý":"y","æ":"ae","œ":"oe" };

  var fontCache = {};    // fontId  -> { p, font, glyphImgs }
  var layoutCache = {};  // layoutId -> { p, MF, topImg, bottomImg }

  function loadImage(src) {
    return new Promise(function (res, rej) {
      var im = new Image(); im.crossOrigin = "anonymous";
      var t = setTimeout(function () { rej(new Error("img timeout " + src)); }, 20000);   // mạng stall -> reject để retry, không treo vĩnh viễn
      im.onload = function () { clearTimeout(t); res(im); };
      im.onerror = function () { clearTimeout(t); rej(new Error("img " + src)); };
      im.src = src;
    });
  }
  function fetchTO(url, opts) {   // fetch + timeout 15s (mobile stall không fire error -> treo cả pipeline render)
    if (typeof AbortController === "undefined") return fetch(url, opts);
    var ac = new AbortController(); opts = opts || {}; opts.signal = ac.signal;
    var t = setTimeout(function () { try { ac.abort(); } catch (e) {} }, 15000);
    var p = fetch(url, opts);
    p.then(function () { clearTimeout(t); }, function () { clearTimeout(t); });
    return p;
  }
  // Warm kết nối R2 sớm -> fetch atlas nhanh hơn khi khách bấm preview.
  try { var _pc = document.createElement("link"); _pc.rel = "preconnect"; _pc.href = R2; _pc.crossOrigin = "anonymous"; document.head.appendChild(_pc); } catch (e) {}

  function ensureFont(fontId) {
    fontId = fontId || DEF_FONT;
    var c = fontCache[fontId];
    if (c && c.ready) return Promise.resolve(c);   // RACE FIX: chỉ nhận entry khi ĐÃ tải xong glyph (không phải chỉ có font.json)
    if (c && c.p) return c.p;
    var ent = { ready: false };
    ent.p = fetchTO(R2 + "/fonts/" + fontId + "/font.json", { mode: "cors", cache: "no-cache" })
      .then(function (r) { if (!r.ok) throw new Error('font "' + fontId + '" ' + r.status); return r.json(); })
      .then(function (f) {
        ent.font = f; ent.glyphImgs = {};
        ent.bodyTop = calcBodyTop(f);   // khung trống trên đầu CHỮ THƯỜNG (font full-frame) -> nâng design khi đặt lên áo

        var fver = f.v ? ("?v=" + encodeURIComponent(f.v)) : "";   // bust cache glyph khi update font
        var jobs = Object.keys(f.glyphs).map(function (ch) {
          return loadImage(R2 + "/fonts/" + fontId + "/glyphs/" + f.glyphs[ch].file + ".webp" + fver).then(function (im) { ent.glyphImgs[ch] = im; });
        });
        return Promise.all(jobs).then(function () { ent.ready = true; return ent; });   // ready = SAU khi mọi glyph load xong
      });
    ent.p.catch(function () { if (fontCache[fontId] === ent) delete fontCache[fontId]; });   // lỗi -> XOÁ cache (không giam rejected promise vĩnh viễn, lần sau retry thật)
    fontCache[fontId] = ent;
    return ent.p;
  }

  function ensureLayout(layoutId) {
    if (!layoutId) return Promise.resolve({ MF: null, topImg: null, bottomImg: null });
    var c = layoutCache[layoutId];
    if (c && c.ready) return Promise.resolve(c);   // RACE FIX: chỉ nhận entry khi ĐÃ tải xong ảnh layout (trước đây "MF" in c bật ngay khi có manifest, ảnh bottom còn null -> render ra chữ TRẦN không layout, phải tắt/mở lại)
    if (c && c.p) return c.p;
    var ent = { ready: false, topImg: null, bottomImg: null };
    ent.p = fetchTO(R2 + "/layouts/" + layoutId + ".json", { mode: "cors", cache: "no-cache" })
      .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; })
      .then(function (MF) {
        ent.MF = MF;
        var jobs = [];
        var hasTop = MF ? !!MF.hasTop : false;
        var hasBottom = MF ? (MF.hasBottom !== false) : true;   // không manifest = layout đơn = bottom
        var ver = (MF && MF.v) ? ("?v=" + encodeURIComponent(MF.v)) : "";
        // KHÔNG nuốt lỗi ảnh layout nữa: fail -> reject để caller retry (nuốt = render thiếu block IM LẶNG hoặc spinner treo)
        if (hasTop) jobs.push(loadImage(R2 + "/layouts/" + layoutId + "/top.webp" + ver).then(function (im) { ent.topImg = im; }));
        if (hasBottom) jobs.push(loadImage(R2 + "/layouts/" + layoutId + ".webp" + ver).then(function (im) { ent.bottomImg = im; }));
        return Promise.all(jobs).then(function () { ent.ready = true; return ent; });   // ready = SAU khi mọi ảnh layout load xong
      });
    ent.p.catch(function () { if (layoutCache[layoutId] === ent) delete layoutCache[layoutId]; });   // lỗi -> xoá cache để retry sạch
    layoutCache[layoutId] = ent;
    return ent.p;
  }

  // bodyTop = median hàng mực ĐẦU TIÊN của các glyph "chữ thường" (bỏ glyph ngắn như gạch/chấm).
  // Font up qua portal giữ FULL khung (không trim dọc) -> chữ thường có khoảng trống trên đầu (khung chừa cho ä/ö/ü cao hơn);
  // đo khoảng cách cổ->chữ theo CHỮ THƯỜNG, không lấy full pixel ký tự đặc biệt. Font crop sát (beer1) -> bodyTop≈0, không đổi gì.
  function calcBodyTop(f) {
    try {
      var ts = [];
      for (var k in f.glyphs) {
        var g = f.glyphs[k], L = g.L; if (!L) continue;
        var t = -1, b = -1;
        for (var i = 0; i < L.length; i++) { if (L[i] !== null) { if (t < 0) t = i; b = i; } }
        if (t < 0) continue;
        if ((b - t + 1) < (f.shortFrac || 0.45) * g.h) continue;   // bỏ glyph ngắn
        ts.push(t);
      }
      if (!ts.length) return 0;
      ts.sort(function (a, b2) { return a - b2; });
      return ts[Math.floor(ts.length / 2)];
    } catch (e) { return 0; }
  }
  function resolveChar(font, ch) {
    var k = ch.toLowerCase();
    if (font.glyphs[k]) return [k];
    var rep = ACCENT[k]; if (!rep) return null;
    var out = []; for (var i = 0; i < rep.length; i++) { if (font.glyphs[rep[i]]) out.push(rep[i]); else return null; } return out;
  }
  function composeName(font, glyphImgs, text) {
    var items = [];
    for (var i = 0; i < text.length; i++) { var ch = text[i];
      if (ch === " ") { items.push({ space: true }); continue; }
      var keys = resolveChar(font, ch); if (!keys) { continue; }
      for (var j = 0; j < keys.length; j++) { var g = font.glyphs[keys[j]]; items.push({ key: keys[j], w: g.w, h: g.h, L: g.L, R: g.R }); }
    }
    var gg = items.filter(function (it) { return !it.space; });
    if (!gg.length) return null;
    var base_h = Math.max.apply(null, gg.map(function (x) { return x.h; }));
    var scFrac = font.shortFrac || 0.45, vC = (font.hyVCenter != null) ? font.hyVCenter : 0.568;
    var gl = items.map(function (it) {
      if (it.space) return { space: true };
      var yo = base_h - it.h;
      // short glyph (gạch/chấm): căn TÂM ink vào vC*base_h -> hết "gạch bị cao"; chữ thường bottom-align
      var top = -1, bot = -1; for (var r = 0; r < it.h; r++) { if (it.L[r] !== null) { if (top < 0) top = r; bot = r; } }
      if (top >= 0 && (bot - top + 1) < scFrac * base_h) yo = Math.round(vC * base_h - (top + bot) / 2);
      return { w: it.w, h: it.h, yoff: yo, L: it.L, R: it.R, t: top, b: bot };
    });
    var space_px = Math.round(base_h * (font.spaceFrac || 0.30));
    var pos = window.computePositions(gl, base_h, (font.gap || 4), space_px, { short_frac: scFrac });
    var W = 1; items.forEach(function (it, i) { if (!it.space) W = Math.max(W, pos[i] + it.w); });
    var c = document.createElement("canvas"); c.width = Math.ceil(W); c.height = base_h; var cx = c.getContext("2d");
    items.forEach(function (it, i) { if (it.space) return; cx.drawImage(glyphImgs[it.key], Math.max(0, pos[i]), gl[i].yoff); });
    // BBOX MỰC THẬT của tên (từ profile L — không getImageData, không taint): tên có dấu inkTop nhỏ hơn, g/j/y inkBot lớn hơn
    var iT = Infinity, iB = -1;
    gl.forEach(function (g) { if (g.space || g.t == null || g.t < 0) return; var a = g.yoff + g.t, b2 = g.yoff + g.b; if (a < iT) iT = a; if (b2 > iB) iB = b2; });
    c._inkTop = (iB >= 0) ? Math.max(0, Math.floor(iT)) : 0;
    c._inkBot = (iB >= 0) ? Math.min(base_h - 1, Math.ceil(iB)) : (base_h - 1);
    return c;
  }
  // Ghép Top·Mid·Bottom (khớp compose_word Python). Cap render ≤1400px cho toDataURL nhanh.
  // nameMaxH (manifest, tỉ lệ theo BỀ RỘNG design): trần chiều cao tên — tên ngắn scale-to-width bị phồng cao (font hẹp) thì thu về trần + căn giữa ngang. KHỚP compose_one Python.
  // FRAME MODE (MF.frame={x,y,anchor}): KHUNG IN ẢO 4200×4800 + CẮT NAME THEO MỰC (khớp PodifyPortal bên portal):
  //  - gap đo đến pixel mực thật -> tên thường co sát, tên có dấu tự giãn, khoảng trên/dưới đúng manifest
  //  - content đặt trong khung theo frame.x/y/anchor; canvas LUÔN tỉ lệ 7:8 -> vị trí trên áo đứng im với mọi tên
  //  - SCALE-FIRST: canvas thật = 1400×1600 (cap 1400 theo bề rộng khung) — KHÔNG render full 4200×4800 (vượt limit canvas iOS)
  var FRAME_W = 4200, FRAME_H = 4800;
  // bbox mực theo chiều dọc của 1 canvas (quét alpha bản 96px, quy về px gốc) — dùng cho anchor "center" (gối/túi)
  function inkBounds(cv) {
    try {
      var S = 96, t = document.createElement("canvas"); t.width = S; t.height = S; var tx = t.getContext("2d"); tx.drawImage(cv, 0, 0, S, S);
      var d = tx.getImageData(0, 0, S, S).data, top = -1, bot = -1;
      for (var y = 0; y < S; y++) { var hit = false; for (var x = 0; x < S; x++) { if (d[(y * S + x) * 4 + 3] > 24) { hit = true; break; } } if (hit) { if (top < 0) top = y; bot = y; } }
      if (top < 0) return null;
      var k = cv.height / S; return { top: top * k, bot: (bot + 1) * k - 1 };
    } catch (e) { return null; }
  }
  function composeTMB(nameCanvas, MF, topImg, bottomImg, bodyTop, anchorOverride) {
    var frame = (MF && MF.frame && typeof MF.frame === "object") ? MF.frame : null;
    // 15/08: phôi PHẲNG (gối/túi) ép anchor "center" -> design LUÔN cân giữa 4 chiều dù tên dài/ngắn (áo giữ anchor manifest = neo trên, cổ áo đứng im)
    if (frame && anchorOverride) frame = { x: frame.x, y: (anchorOverride === "center" ? 0 : frame.y), anchor: anchorOverride };
    // layout LEGACY không frame (vd -b/-c) + override center -> dựng khung ảo 7:8 để cân được (legacy trả content trần = neo mép trên trên PDP)
    if (!frame && anchorOverride === "center") frame = { x: 0, y: 0, anchor: "center" };
    var Wm = (MF && MF.width) ? MF.width : (bottomImg ? bottomImg.naturalWidth : (topImg ? topImg.naturalWidth : nameCanvas.width));
    var sc = frame ? (Math.min(FRAME_W, 1400) / FRAME_W) : (Math.min(Wm, 1400) / Wm);
    var W = Math.max(1, Math.round(Wm * sc));   // bề rộng CONTENT đã scale (frame: Wm = bề rộng design TRONG khung, px khớp PS)
    var gapTM = Math.round((MF ? (MF.spaceTopMid || 0) : 0) * sc), gapMB = Math.round((MF ? (MF.spaceMidBottom || 0) : 0) * sc);
    var nh = Math.max(1, Math.round(nameCanvas.height * (W / nameCanvas.width))), nw = W;
    // trần theo phần MỰC THẬT (trừ khung trống trên đầu chữ thường bodyTop) -> 0.33 = khớp V1 với MỌI font, kể cả font full-frame
    var inkScale = nameCanvas.height / Math.max(1, nameCanvas.height - (bodyTop || 0));
    var capH = (MF && MF.nameMaxH > 0) ? Math.round(MF.nameMaxH * W * inkScale) : 0;
    if (capH && nh > capH) { nw = Math.max(1, Math.round(nameCanvas.width * (capH / nameCanvas.height))); nh = capH; }
    // frame: vẽ LÁT MỰC (bbox từ profile) thay vì full khung glyph — cỡ chữ GIỮ NGUYÊN (cùng hệ số scale nh/srcH)
    var srcH = nameCanvas.height;
    var iT = frame ? (nameCanvas._inkTop || 0) : 0, iB = frame ? ((nameCanvas._inkBot != null) ? nameCanvas._inkBot : srcH - 1) : (srcH - 1);
    var inkH = Math.max(1, iB - iT + 1), nameH = frame ? Math.max(1, Math.round(inkH * (nh / srcH))) : nh;
    // CÂN GIỮA khi có dấu (chốt 07/07, khớp PodifyPortal): dấu vươn trên đầu chữ ext px -> cộng đúng ext vào gap DƯỚI để THÂN CHỮ đứng giữa Top–Bottom.
    // Chỉ áp khi có đủ Top+Bottom (name ở mid); ngưỡng 5% chống nhiễu đo (bodyTop là median).
    // dấu vươn trên thân chữ -> tên có KÝ TỰ ĐẶC BIỆT (Ä Ö Ü…). Phát hiện từ profile mực (không cần text).
    var accent = frame ? ((((bodyTop || 0) - iT) > 0.05 * srcH)) : false;
    var ext = 0;
    if (frame && topImg && bottomImg) { var e0 = (bodyTop || 0) - iT; if (e0 > 0.05 * srcH) ext = Math.round(e0 * (nh / srcH)); }
    // USER 08/07: tên có dấu -> ÉP gap trên & dưới về 0 (kéo tên sát lại), GIỮ ext (bottom tự giãn đúng chiều cao dấu
    // -> thân chữ vẫn cân giữa). Tên thường không dấu: ext vốn = 0, gap giữ nguyên cấu hình. KHỚP PodifyPortal.
    if (accent) { gapTM = 0; gapMB = 0; }
    var parts = [];
    if (topImg) { parts.push({ img: topImg, h: Math.round(topImg.naturalHeight * (W / topImg.naturalWidth)) }); parts.push({ h: gapTM }); }
    parts.push({ name: nameCanvas, h: nameH, nw: nw });
    if (bottomImg) { parts.push({ h: gapMB + ext }); parts.push({ img: bottomImg, h: Math.round(bottomImg.naturalHeight * (W / bottomImg.naturalWidth)) }); }
    var total = 0; parts.forEach(function (p) { total += p.h; }); if (total < 1) total = 1;
    var c = document.createElement("canvas"); c.width = W; c.height = total; var cx = c.getContext("2d"); cx.imageSmoothingQuality = "high";
    var y = 0; parts.forEach(function (p) { if (p.name) cx.drawImage(p.name, 0, iT, p.name.width, inkH, Math.round((W - p.nw) / 2), y, p.nw, p.h); else if (p.img) cx.drawImage(p.img, 0, y, W, p.h); y += p.h; });
    if (!frame) { c._nameH = nh; return c; }   // legacy: trả content trần (lift bodyTop như cũ)
    // đặt content vào khung ảo (fit-shrink nếu tràn; kẹp trong khung)
    var fw = Math.max(1, Math.round(FRAME_W * sc)), fh = Math.max(1, Math.round(FRAME_H * sc));
    var f = document.createElement("canvas"); f.width = fw; f.height = fh; var fx = f.getContext("2d"); fx.imageSmoothingQuality = "high";
    var fit = Math.min(1, fw / c.width, fh / c.height), dw = c.width * fit, dh = c.height * fit;
    var ox = (parseFloat(frame.x) || 0) * sc, oy = (parseFloat(frame.y) || 0) * sc, an = frame.anchor || "top";
    var x0 = (fw - dw) / 2 + ox;
    var y0 = an === "top" ? oy : (an === "bottom" ? (fh - dh - oy) : ((fh - dh) / 2 + oy));
    if (an === "center") {
      // 15/08 (gối/túi): content c cao ~ khung (mảnh design có padding trong suốt riêng) -> (fh-dh)/2 KHÔNG cân mực.
      // Căn theo BBOX MỰC của c: tâm mực = tâm khung (+oy).
      var ib = inkBounds(c);
      if (ib) {
        // mực cao hơn khung (tên ngắn -> design dài) -> co thêm để mực lọt khung, rồi mới cân (không thì bị kẹp mép trên)
        var inkH = (ib.bot - ib.top + 1) * fit;
        if (inkH > fh * 0.96) { var k2 = (fh * 0.96) / inkH; fit *= k2; dw = c.width * fit; dh = c.height * fit; x0 = (fw - dw) / 2 + ox; }
        var inkMid = ((ib.top + ib.bot + 1) / 2) * fit; y0 = fh / 2 - inkMid + oy;
      }
    }
    x0 = Math.max(0, Math.min(fw - dw, x0));
    // center: KHÔNG kẹp y0 (content c cao ~ khung -> kẹp về 0 giết luôn phép căn; phần tràn khung là viền trong suốt, vô hại)
    if (an !== "center") y0 = Math.max(0, Math.min(fh - dh, y0));
    fx.drawImage(c, x0, y0, dw, dh);
    f._frame = true; f._nameH = 0;   // _nameH=0 -> render() KHÔNG lift bodyTop (khung đã cắt theo mực)
    return f;
  }
  // Căn design lên mockup — CÔNG THỨC V1 (MOCK=2000, aspect ĐỘNG). Trả % top/left/width/height.
  function placeTLW(place, aspect) {
    place = place || {}; var MOCK = place.mock || 2000, maxW = place.maxW || 1040, offX = place.offX || 0, offY = place.offY || 0, anchor = place.anchor || "top";
    var hpx = maxW * aspect; var leftPx = (MOCK - maxW) / 2 + offX;
    var topPx = anchor === "top" ? offY : (anchor === "bottom" ? (MOCK - hpx - offY) : ((MOCK - hpx) / 2 + offY));
    return { top: Math.round(topPx / MOCK * 1000) / 10, left: Math.round(leftPx / MOCK * 1000) / 10, width: Math.round(maxW / MOCK * 1000) / 10, height: Math.round(hpx / MOCK * 1000) / 10 };
  }

  var api = {
    ready: false,
    // preload atlas bộ đang chọn (mặc định nếu không truyền) — gọi sớm cho snappy
    preload: function (fontId, layoutId) { return Promise.all([ensureFont(fontId || DEF_FONT), ensureLayout(layoutId != null ? layoutId : DEF_LAYOUT)]); },
    // Ký tự KHÔNG render được với font này (không glyph + không map accent) -> widget chặn nhập + cảnh báo.
    badChars: function (text, fontId) {
      return ensureFont(fontId || DEF_FONT).then(function (fe) {
        var bad = [];
        for (var i = 0; i < (text || "").length; i++) {
          var ch = text[i]; if (ch === " ") continue;
          if (!resolveChar(fe.font, ch) && bad.indexOf(ch) < 0) bad.push(ch);
        }
        return bad;
      }).catch(function () { return []; });   // font lỗi -> đừng chặn khách
    },
    render: function (name, opts) {
      opts = opts || {};
      var fontId = opts.fontId || DEF_FONT;
      var layoutId = (opts.layoutId != null) ? opts.layoutId : DEF_LAYOUT;
      return Promise.all([ensureFont(fontId), ensureLayout(layoutId)]).then(function (a) {
        var fe = a[0], le = a[1];
        // GUARD: layout CÓ mã nhưng KHÔNG ảnh nào tải được -> layout chưa sẵn, trả null để widget retry (đừng render chữ TRẦN không design)
        if (layoutId && !le.topImg && !le.bottomImg) return null;
        var nc = composeName(fe.font, fe.glyphImgs, (name || "").trim()); if (!nc) return null;
        var d = composeTMB(nc, le.MF, le.topImg, le.bottomImg, fe.bodyTop || 0, opts.anchor || null);
        var aspect = d.height / d.width;
        var tlw = (le.MF && le.MF.place) ? placeTLW(le.MF.place, aspect)
          : (PA ? { top: PA.top, left: PA.left, width: PA.width, height: PA.height } : null);
        // NÂNG design lên phần khung trống trên đầu chữ thường -> offY = khoảng cách cổ->MẶT CHỮ (ký tự đặc biệt ä/ö/ü vươn lên trên, không tính)
        if (tlw && fe.bodyTop > 0 && d._nameH) {
          var liftPct = (fe.bodyTop * (d._nameH / nc.height) / d.width) * tlw.width;   // % theo mock (cùng đơn vị tlw)
          tlw = { top: Math.round((tlw.top - liftPct) * 10) / 10, left: tlw.left, width: tlw.width, height: tlw.height };
        }
        // toBlob (ASYNC, không block main thread) + objectURL (nhỏ, không phải base64 ~3.4MB) + trả canvas để tái dùng (khỏi decode lại)
        return new Promise(function (resolve) {
          d.toBlob(function (b) {
            resolve({ url: b ? URL.createObjectURL(b) : d.toDataURL("image/png"), blob: b, canvas: d, w: d.width, h: d.height, tlw: tlw, mfPa: (le.MF && le.MF.pa && typeof le.MF.pa === "object") ? le.MF.pa : null, layoutId: layoutId });   // mfPa: PA per phôi từ manifest layout (1 NGUỒN vị trí — 15/08)
          }, "image/webp", 0.9);
        });
      }).catch(function () { return null; });
    }
  };
  window.PodifyCanvas = api;

  // preload atlas CHỈ khi có TÍN HIỆU Ý ĐỊNH (chạm/focus/hover ô tên) — KHÔNG idle-preload cho mọi khách nữa
  // (idle-preload = ~40 glyph webp + ảnh layout cho 100% pageview -> PDP mobile nặng thêm ~40 request vô ích;
  //  khách thật sự gõ tên: preload bắt đầu từ lúc chạm ô, atlas kịp sẵn trước khi bấm preview, đã có spinner đỡ ca chậm)
  function attach() {
    var inp = document.querySelector("[data-r2p-input]");
    if (!inp) return;
    var warmed = false;
    var warm = function () { if (warmed) return; warmed = true; api.preload(); };
    inp.addEventListener("focus", warm, { once: true });
    inp.addEventListener("pointerenter", warm, { once: true });
    inp.addEventListener("touchstart", warm, { once: true, passive: true });
    // 17/07: warm SỚM khi widget vào viewport (khách cuộn tới khu personalize) — atlas sẵn TRƯỚC khi khách gõ xong tên,
    // preview hết chờ 2-5s (trade-off của fix bỏ idle-preload 16/07). CHỈ observe SAU window load -> không tranh băng thông
    // với ảnh lúc trang đang tải (desktop widget hiện ngay từ đầu cũng chỉ warm sau load). Bounce-visitor không cuộn tới = vẫn 0 request.
    function obs() {
      if (warmed) return;
      if (!("IntersectionObserver" in window)) return;
      var io = new IntersectionObserver(function (es) {
        for (var i = 0; i < es.length; i++) { if (es[i].isIntersecting) { warm(); io.disconnect(); return; } }
      }, { rootMargin: "150px 0px" });
      io.observe(inp);
    }
    if (document.readyState === "complete") obs(); else window.addEventListener("load", obs);
  }
  if (document.readyState !== "loading") attach(); else document.addEventListener("DOMContentLoaded", attach);
})();
